import React from 'react';
import Type from './Type.js';

const Strong = props => /*#__PURE__*/React.createElement(Type, props, props.children);
Strong.defaultProps = {
  tag: 'strong',
  font: 'inherit',
  weight: 'bold',
  display: 'inline'
};

export { Strong as default };
